export default __webpack_public_path__ + "static/media/bg.21897109.svg";